import React from "react";
import styled from "styled-components";
import BaggageFeesLink from "./BaggageFeesLink";

// Styles
const Wrapper = styled.div`
  margin-top: 15px;
  font-size: 0.8em;
`;
const BaggageFeesDisclaimer = () => (
  <Wrapper>
    Total price includes taxes and fees. Prices are not guaranteed until
    purchase is complete. <BaggageFeesLink /> are not included in your trip
    cost. 
  </Wrapper>
);

export default BaggageFeesDisclaimer;



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/ChargesSummary/BaggageFeesDisclaimer/index.js